export enum TableMode {
    Open,
    Close,
    InternalTest,
}
